// Square location IDs for the two stores
export const STORES = [
  { name: 'Muncie', id: 'LZYT354SRGXAY' },
  { name: 'Carmel', id: 'LMMVB5ATCP112' },
];
